import { TableBody } from '@client/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
import { BuildingRow } from './building-row';
import { TenantRow } from './tenant-row';
import { BuildingOverdueInvoicesDto, TenantOverdueInvoicesDto } from '@client/api';

export const OverdueInvoicesTable: React.FC<{
  data: BuildingOverdueInvoicesDto[];
  loading: boolean;
  onSelected: (ids: Set<string>) => void;
}> = ({ data = [], loading, onSelected }) => {
  const { t } = useTranslation('reporting');

  const columns = [
    { key: 'name', label: t('overdueInvoices.building') },
    { key: 'tenants', label: t('overdueInvoices.tenants') },
    { key: 'totalOverdue', label: t('overdueInvoices.totalOverdue') },
    { key: 'invoiceNumber', label: t('overdueInvoices.invoiceNumber') },
    { key: 'invoicesDes', label: t('overdueInvoices.invoicesDes') },
    { key: 'dueDate', label: t('overdueInvoices.dueDate') },
    { key: 'daysOverdue', label: t('overdueInvoices.daysOverdue') },
  ];
  return (
    <ExpanableTableWraper
      columns={columns}
      loading={loading}
      data={data}
      onSelected={onSelected}
      renderBody={(
        data,
        selectedRows,
        expandedRows,
        handleToggleSelect,
        handleKeyDownSelect,
        handleToggleExpand,
        handleKeyDownExpand,
      ) => (
        <TableBody>
          {data.map((building) => (
            <React.Fragment key={building.buildingId}>
              <BuildingRow
                building={building}
                selectedRows={selectedRows}
                handleToggleSelect={handleToggleSelect}
                handleKeyDownSelect={handleKeyDownSelect}
                handleToggleExpand={handleToggleExpand}
                handleKeyDownExpand={handleKeyDownExpand}
                expandedRows={expandedRows}
              />
              {expandedRows.has(building.buildingId) &&
                building.tenantOverdueInvoices.map((tenant: TenantOverdueInvoicesDto) => (
                  <TenantRow
                    key={tenant.tenantId}
                    tenant={tenant}
                    handleToggleExpand={handleToggleExpand}
                    handleKeyDownExpand={handleKeyDownExpand}
                    expandedRows={expandedRows}
                  />
                ))}
            </React.Fragment>
          ))}
        </TableBody>
      )}
    />
  );
};
